// Warehouses often ship with company_name null and the label in name.
// Locations usually already have company_name. A person record may only
// have first_name and last_name. Returns "" when none of those are set.
export function resolveCompanyName(item) {
  if (!item) return "";
  return (
    item.company_name ||
    item.name ||
    [item.first_name, item.last_name].filter(Boolean).join(" ")
  );
}

// Cross-dock Company field. Only a warehouse pick (l_type "WH") falls back to
// name or first/last. Any other pick keeps company_name as stored, so an
// individual address is not filled from those fields. An empty warehouse
// fallback keeps priorCompanyName.
export function companyNameForCrossDockPick(item, priorCompanyName = "") {
  if (item?.l_type !== "WH") return item?.company_name || "";
  return resolveCompanyName(item) || priorCompanyName || "";
}
